import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import VidyardEmbed from '@vidyard/embed-code';

@Component({
  selector: 'vex-on-demand-video',
  templateUrl: './on-demand-video.component.html',
  styleUrls: ['./on-demand-video.component.scss']
})
export class OnDemandVideoComponent implements OnInit {
  video;
  parsedPdf;
  miniSpinnerPlay: boolean = false;
  currentLang: string;
  showTest: boolean = false;

  constructor(public guiService: GuiService, public translate: TranslateService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if(sessionStorage.getItem('selectedOndemandVideo')){
      this.currentLang = this.translate.currentLang.toUpperCase()
      this.video = null;
      setTimeout(() => {
        this.video = JSON.parse(sessionStorage.getItem('selectedOndemandVideo'));
        console.debug('selected video', this.video)
        this.parsedPdf = this.video.pdf ? JSON.parse(this.video.pdf) : null;
      }, 200);
    }else{
      this.guiService.goTo('main/on-demand')
    }
  }

  showVideo() {
    const placeholderImage = document.querySelector('img.vidyard-player-embed');
    placeholderImage.setAttribute('src', `https://play.vidyard.com/${this.video.i18nvideoId[this.currentLang]}.jpg`)
    placeholderImage.setAttribute('data-uuid', this.video.i18nvideoId[this.currentLang])

    this.miniSpinnerPlay = true;
    let ref = this;

    setTimeout(() => {
      VidyardEmbed.api.renderDOMPlayers()
    const players = VidyardEmbed.api.getPlayersByUUID(this.video.i18nvideoId[this.currentLang]);
    const playerIndex = players.length - 1
    console.debug(players)
    players[playerIndex].ready();
    players[playerIndex].on('ready', function () {
      console.debug('PLAYER READY')
      players[playerIndex].pause();
      players[playerIndex].play()
    })

    players[playerIndex].on('play', function () {

      setTimeout(() => {
        players[playerIndex].toggleFullscreen()
        console.debug('PLAYER IN PLAY IN FULLSCREEN')
      }, 1700);

    })

    players[playerIndex].on('pause', function () {
      console.debug('PLAYER PAUSED')
    })

    players[playerIndex].on()
    }, 0);

    setTimeout(() => {
      ref.miniSpinnerPlay = false;
    }, 2000);
  }

  downloadPdf(){
    this.guiService.goToExternalLink(this.parsedPdf[this.currentLang]);
  }
}

